import { memo } from "react";
import type { SettlementStatus as TransactionSettlementStatus } from "types";
import { SettlementStatus } from "consts/transactions";
import withChipStatus from "./withChipStatus";
import type { ChipStatusProps } from "./types";

export default memo(withChipStatus<TransactionSettlementStatus>(
    new Map<TransactionSettlementStatus, ChipStatusProps<TransactionSettlementStatus>>()
        .set(SettlementStatus.Succeeded, {
            icon: 'CheckCircleOutline',
            color: 'success'
        })
        .set(SettlementStatus.FundsMissing, {
            icon: 'SmsFailed',
            color: 'error'
        })
        .set(SettlementStatus.FundsReceived, {
            icon: 'ThumbUp',
            color: 'secondary'
        })
        .set(SettlementStatus.FundsRefunded, {
            icon: 'LocalAtm',
            color: 'warning'
        })
        .set(SettlementStatus.FundsSent, {
            icon: 'Outbox',
            color: 'info'
        })
));
